import React, { PropsWithChildren } from 'react';

import { ASComponentSize, ComponentSize } from '@eleventheye/asui';
import styles from './TeamField.module.scss';

export type TeamFieldProps = {
  className?: string;
  text?: string | number;
  textLabel?: string;
  wrap?: boolean;
  labelMinWidth?: number; // in pixels
  withShadow?: boolean;
  textSize?: ASComponentSize;
  capitalize?: boolean;
  labelSize?: ASComponentSize;
  showWarning?: boolean;
  warningText?: string;
};

const TeamField: React.FC<PropsWithChildren<TeamFieldProps>> = ({
  className = '',
  text = '',
  textLabel,
  children,
  wrap = false,
  labelMinWidth = 0,
  withShadow = false,
  textSize = ComponentSize.Medium,
  labelSize = ComponentSize.Small,
  capitalize = false,
  showWarning = false,
  warningText = '',
}) => {
  const wrapCls = wrap ? '' : styles.TeamFieldNoWrap;
  const shadowCls = withShadow ? styles.TeamFieldWithShadow : '';
  const baseCls = `${className} ${styles.TeamField} ${wrapCls}`;
  const capitalizeCls = capitalize ? styles.TeamFieldsCapitalizeTxt : '';

  const getLabel = () => {
    return textLabel || children ? (
      <span className={`${styles.TeamFieldLabel} ${styles[labelSize]}`} style={{ minWidth: `${labelMinWidth}px` }}>
        {textLabel || children}
      </span>
    ) : null;
  };

  const textCls = `${styles.TeamFieldText} ${shadowCls} ${capitalizeCls}}`;

  const warning = showWarning ? (
    <span className={styles.TeamFieldWarning} title={warningText}>
      ⚠
    </span>
  ) : null;

  return (
    <span className={baseCls}>
      {getLabel()}
      <span className={`${textCls} ${styles[textSize]}`}>
        {text.toLocaleString()}
        {children}
        {warning}
      </span>
    </span>
  );
};

type TeamFieldsOwnProps = {
  className?: string;
};
type TeamFieldsProps = PropsWithChildren<TeamFieldsOwnProps>;
const TeamFields: React.FC<TeamFieldsProps> = ({ className = '', children }) => {
  const baseCls = `${styles.TeamFieldsContainer} ${className}`;
  return <span className={baseCls}>{children}</span>;
};

export { TeamField as default, TeamFields };
